import {AfterViewChecked, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {ConstantsService} from '../../../core/services/constants.service';
import {isNil} from 'lodash-es';

@Component({
    selector: 'app-instrument-column',
    templateUrl: './instrument-column.component.html',
    styleUrls: ['./instrument-column.component.scss'],
    standalone: false
})
export class InstrumentColumnComponent implements OnInit, OnChanges, AfterViewChecked {
    @Input()
    parentFormGroup: UntypedFormGroup;

    @Input()
    dynamicFormControlName: string;

    @Input()
    columnConfig: any;

    @Input()
    numberOfLegs: number;

    @Input()
    disableControl?: any;

    @Input()
    mode: string;

    @Output() selectOptionChange = new EventEmitter<any>();

    leg1DynamicFormControlName: string;
    leg2DynamicFormControlName: string;
    inputFocus1 = false;
    inputFocus2 = false;
    leg1ControlInfoList = [];
    leg2ControlInfoList = [];
    modelPopupMode: any;

    constructor(private constantsService: ConstantsService, private cdRef: ChangeDetectorRef) {
    }

    ngAfterViewChecked() {
        this.cdRef.detectChanges();
    }

    ngOnInit() {
        this.modelPopupMode = this.constantsService.modelPopupMode;
        this.leg1DynamicFormControlName = 'leg1' + this.dynamicFormControlName;
        this.leg2DynamicFormControlName = 'leg2' + this.dynamicFormControlName;
        this.parentFormGroup.controls[this.leg1DynamicFormControlName]
            .setValidators(this.constantsService.instrumentFieldValidations[this.leg1DynamicFormControlName].validators);
        this.leg1ControlInfoList = this.constantsService.instrumentFieldValidations[this.leg1DynamicFormControlName].validationMessages;
        if (this.mode === this.modelPopupMode.view && !isNil(this.parentFormGroup.controls[this.leg1DynamicFormControlName])) {
            this.parentFormGroup.controls[this.leg1DynamicFormControlName].disable();
        }

        if (this.numberOfLegs > 1 && !this.columnConfig.sameForBothLeg) {
            this.parentFormGroup.controls[this.leg2DynamicFormControlName]
                .setValidators(this.constantsService.instrumentFieldValidations[this.leg2DynamicFormControlName].validators);
            this.leg2ControlInfoList = this.constantsService.instrumentFieldValidations[this.leg2DynamicFormControlName].validationMessages;
            if (this.mode === this.modelPopupMode.view && !isNil(this.parentFormGroup.controls[this.leg2DynamicFormControlName])) {
                this.parentFormGroup.controls[this.leg2DynamicFormControlName].disable();
            }
        }

        if (this.columnConfig.selectOptions !== undefined && this.columnConfig.selectOptions !== null) {
            this.subscribeToSelectValueChange();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        this.onSelectedOptionChange(changes);
        this.onDisableControlChange(changes);
    }

    onSelectedOptionChange(changes: SimpleChanges) {
        if (!changes.selectOptions || changes.selectOptions.firstChange) {
            return;
        }

        this.columnConfig.selectOptions = changes.selectOptions.currentValue;
    }

    onDisableControlChange(changes: SimpleChanges) {
        if (!changes.disableControl || changes.disableControl.firstChange) {
            return;
        }
        const altLeg = {
            leg1: 'leg2',
            leg2: 'leg1'
        };
        const disableObj = changes.disableControl.currentValue;
        if (disableObj.value === true) {
            this.parentFormGroup.controls[disableObj.leg + this.dynamicFormControlName].setValue('');
            this.parentFormGroup.controls[disableObj.leg + this.dynamicFormControlName].markAsPristine();
            this.parentFormGroup.controls[disableObj.leg + this.dynamicFormControlName].disable();
            /*
            if (altLeg[disableObj.leg]) {
                this.parentFormGroup.controls[altLeg[disableObj.leg] + this.dynamicFormControlName].enable();
            }
            */
        } else {
            this.parentFormGroup.controls[disableObj.leg + this.dynamicFormControlName].enable();
            /*
            if (altLeg[disableObj.leg]) {
                const alt = altLeg[disableObj.leg];
                this.parentFormGroup.controls[alt + this.dynamicFormControlName].setValue('');
                this.parentFormGroup.controls[alt + this.dynamicFormControlName].markAsPristine();
                this.parentFormGroup.controls[alt + this.dynamicFormControlName].disable();
            }
            */
        }
    }

    subscribeToSelectValueChange() {
        this.parentFormGroup.get(this.leg1DynamicFormControlName).valueChanges.subscribe(
            (selected: string) => {
                if (!selected || selected === '') {
                    return;
                }

                if (this.columnConfig.onLeg1Change && (typeof this.columnConfig.onLeg1Change === 'function')) {
                    const formControl = this.parentFormGroup.get(this.leg2DynamicFormControlName) as UntypedFormControl;
                    this.columnConfig.onLeg1Change(selected, formControl);
                }
                this.selectOptionChange.emit({leg: 'leg1', value: selected});
            });

        if (this.numberOfLegs > 1 && !this.columnConfig.sameForBothLeg) {
            this.parentFormGroup.get(this.leg2DynamicFormControlName).valueChanges.subscribe(
                (selected: string) => {
                    if (!selected || selected === '') {
                        return;
                    }

                    if (this.columnConfig.onLeg2Change && (typeof this.columnConfig.onLeg2Change === 'function')) {
                        const formControl = this.parentFormGroup.get(this.leg1DynamicFormControlName) as UntypedFormControl;
                        this.columnConfig.onLeg2Change(selected, formControl);
                    }
                    this.selectOptionChange.emit({ leg: 'leg2', value: selected });
                });
        }
    }

    isInvalidAndDirty(groupControl, columnName) {
        if (!groupControl || !columnName || !groupControl.controls[columnName]) {
            return true;
        }
        return !groupControl.controls[columnName].valid && groupControl.controls[columnName].dirty;
    }

    isInvalidAndTouched(groupControl, columnName) {
        if (!groupControl || !columnName || !groupControl.controls[columnName]) {
            return true;
        }
        return !groupControl.controls[columnName].valid && groupControl.controls[columnName].touched;
    }

    onInputFocus(legType: string) {
        if (legType === 'leg1') {
            this.inputFocus1 = true;
        } else {
            this.inputFocus2 = true;
        }
    }

    onInputBlurr(legType: string) {
        if (legType === 'leg1') {
            this.inputFocus1 = false;
        } else {
            this.inputFocus2 = false;
        }
    }

    isString(value): boolean {
        return (typeof value) === 'string';
    }
}
